var Accordeon = {

	timeout_scroll:0,
	array_dest:[],
	decal_scroll:70,
	hasDragged : false,

	init:function(){

		$(window).resize(function(){
			Accordeon.resize();
		});

		setTimeout(function(){
			Accordeon.resize();

			$("[accordeon-container] .title").on("touchmove", function(){
				Accordeon.hasDragged = true;				
			});
			$("[accordeon-container] .title").on("click touchend", function(e){
				if(e.type == "touchend"){
					$(this).off("click");
				}
				if(Accordeon.hasDragged == false){
					Accordeon.clickOn($(this).parent());
				}
				
				Accordeon.hasDragged = false;
			});

		}, 500);




	},
	resize:function(){
		Accordeon.array_dest = [];
		/* MEMORISE LES POSITIONS POUR SCROLL DEST SI BESOIN	*/
		$("[accordeon-scroll] .item").each(function(i){

			$(this).find(".texte-container").addClass("no-anime");
			Accordeon.close($(this));

			/*Debug.log("PUSH : "+ i+ " ==> Position : " + Math.round($(this).position().top) + "  // offset : " + + $(this).offset().top);*/
			Accordeon.array_dest.push({id:i, _y:Math.round($(this).offset().top - Accordeon.decal_scroll)});

			$(this).attr({"data-id":i});

			$(this).find(".texte-container").removeClass("no-anime");
		});
	},
	clickOn:function(pTarget){
		pTarget.parent().find(".item").each(function(){
			if($(this).index() == pTarget.index()){

				if($(this).hasClass("open")){
					Accordeon.close($(this));	
				}else{
					Accordeon.open($(this));	
				}

			}else{
				Accordeon.close($(this));
			}
		});

	},
	open:function(pTarget){

		clearTimeout(Accordeon.timeout_scroll);

		/*Debug.log("OPEN ACCORDEON : has to scroll : " + $("[accordeon-container]").is("[accordeon-scroll]"));*/

		if(pTarget.parent().is("[accordeon-scroll]")){

			for(var i = 0; i < Accordeon.array_dest.length; i++){

				if(Accordeon.array_dest[i].id == pTarget.attr("data-id")){				
					var _scroll_dest = Accordeon.array_dest[i]._y;
					$('html, body').animate({scrollTop:_scroll_dest}, 400);
				}
			}
		}

		pTarget.addClass('open');
		var _h_dest = pTarget.find(".texte").outerHeight();	
		pTarget.find(".texte-container").css({height:_h_dest});

		Accordeon.timeout_scroll = setTimeout(function(){
			$("[accordeon-container]").each(function(){

				if(Math.abs( $(this).find(".item.open .texte-container").outerHeight() - $(this).find(".item.open .texte").outerHeight()) > 5){
					$(this).find(".item.open").addClass("scroll");
				}
			});

		}, 500);
	},
	close:function(pTarget){

		//*clearTimeout(Accordeon.timeout_scroll);*/

		pTarget.removeClass('open scroll');
		pTarget.find(".texte-container").css({height:0});
	}
}


$(document).ready(function(){
	if($("[accordeon-container]").length){
		Accordeon.init();
	}
});